
import RcTableViewModel from '@/portals/shared/table/RcTableViewModel.js';

import ContentUtils from '@/utils/ContentUtils.js';

import CompanyAddressUpdateViewUtils from "./CompanyAddressUpdateViewUtils.js";

export default class AddViewModel extends RcTableViewModel {

  constructor(panel, vehicle) {
    super(panel);
    this._companyId = ContentUtils.baseDecode(panel.$route.params.operatorId);
    this._vehicle = vehicle;
  }


  start() {
    super.start();
  }

  isAdmin() {
    return super.isAdmin();
  }

  withValue(valueData) {
    super.withValue(valueData, "vehicle");
    if (!valueData) {
      return;
    }

    this.domain().logger().info("Received: {0}", [JSON.stringify(valueData, null, 2)]);
  }

  withButtonPressed(buttonData) {
    super.withButtonPressed(buttonData);
    if (!buttonData) {
      return;
    }
  }

  buildRowData(tableData) {
    var utils = new CompanyAddressUpdateViewUtils(this, tableData);
    utils.start();
    return this;
  }

  loadData() {
    this
      .withStateContentLoading()
      .clearAndBuildTableData()
      .done();
  }

  loadedDate(notification, context) {
    if (notification || context) {
      //
    }
  }
}